import { render, staticRenderFns } from "./Skv.vue?vue&type=template&id=2c40c5a6&scoped=true"
import script from "./Skv.vue?vue&type=script&lang=js"
export * from "./Skv.vue?vue&type=script&lang=js"
import style0 from "./Skv.vue?vue&type=style&index=0&id=2c40c5a6&prod&lang=scss&scoped=true"
import style1 from "./Skv.vue?vue&type=style&index=1&id=2c40c5a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c40c5a6",
  null
  
)

export default component.exports